import InstrumentRunner from "@/pages/portal/tools/InstrumentRunner";
import { GAD7_ITEMS, FOUR_POINT_SCALE, interpretGAD7 } from "@/data/instruments";

export default function GAD7() {
  return (
    <InstrumentRunner
      kind="gad7"
      testidPrefix="gad7"
      overline="Portal · Tool"
      title="GAD-7"
      subtitle="Generalized Anxiety Disorder measure — 7 items. Used at admission, weekly, and at every level-of-care transition."
      items={GAD7_ITEMS}
      scale={FOUR_POINT_SCALE}
      interpret={interpretGAD7}
    />
  );
}
